import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import convertType from './plugins/convertType.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
	faPlay,
	faPause,
	faVolumeXmark,
	faVolumeHigh,
	faExpand,
	faArrowRotateLeft,
	faArrowRotateRight,
	faList,
	faShareFromSquare,
	faCircleXmark,
	faArrowLeft,
	faSpinner
} from '@fortawesome/free-solid-svg-icons'

import { faTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons'

library.add(
	faPlay,
	faPause,
	faVolumeXmark,
	faVolumeHigh,
	faExpand,
	faArrowRotateLeft,
	faList,
	faArrowRotateRight,
	faShareFromSquare,
	faCircleXmark,
	faTwitter,
	faFacebookF,
	faArrowLeft,
	faSpinner
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(convertType)

new Vue({
	store,
	router,
	render: (h) => h(App)
}).$mount('#app')

const urlParams = new URLSearchParams(window.location.search);
const loadFrom = urlParams.get("loadFrom");
if (loadFrom) {
    window._paq.push(["trackEvent", "loadFrom", loadFrom, ""]);
}